import { createRoute, Outlet } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { SlidesLibrary } from "@/features/documents/components/slides-library";

/** Layout passthrough so `/slides` (library) and `/slides/$pageId` (editor) coexist. */
function SlidesLayout() {
  return (
    <div class="flex h-full min-h-0 flex-1">
      <Outlet />
    </div>
  );
}

export const slidesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/slides",
  component: SlidesLayout,
});

export const slidesIndexRoute = createRoute({
  getParentRoute: () => slidesRoute,
  path: "/",
  component: SlidesLibrary,
});
